// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__w0Zbk","loaderOuter":"PageOverlayLoader_loaderOuter__M0KPn"};